import { CustomField } from 'types/customFields';
import { portalAPI } from './portalAPI';

const APICustomFieldsSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getCustomFieldsList: builder.query<CustomField[], void>({
            query: () => 'v1/custom-fields',
            // Load the custom fields list only once in 24 hours
            keepUnusedDataFor: 60 * 60 * 24,
        }),
    }),
    overrideExisting: false,
});

export const { useGetCustomFieldsListQuery } = APICustomFieldsSlice;
